import React from 'react';
import { useFormContext } from 'react-hook-form';
import { css } from '@emotion/react';
import { FileData, FileUploadField } from '@bucketplace/commerce-admin-ui';

import { useEditorInfoContext } from '../../../contexts';
import { LottiePreview } from './LottiePreview';

const PATH = 'uploads/exhibitions/contents/contest_description';
const DEFAULT_LIMIT = 10 * 1024;
const ACCEPT = '.json';

export function LottieUploadField({
  name,
}: {
  name: string,
}): React.ReactElement {
  const { uploadEndpoint } = useEditorInfoContext();
  const { watch } = useFormContext();
  const files = watch(name);

  return (
    <>
      {
        !files?.length
          ? (
            <FileUploadField
              name={name}
              endpoint={uploadEndpoint}
              path={PATH}
              accept={ACCEPT}
              isPrivateFile={false}
              fileLimitSize={DEFAULT_LIMIT}
              useArrayType={false}
              serializer={{
                serialize: (url: string) => ({ url }),
                deserialize: (data: FileData) => data.url,
              }}
              customCss={FileUploadFieldCss}
            />
          )
          : <LottiePreview name={name} />
      }
    </>
  );
}

const FileUploadFieldCss = css`
  margin-bottom: 4px;
`;

